import { ReactComponent as Checked } from '@public/icons/checked.svg';
import Icon from '../atoms/Icon';

const IconChecked = (props) => <Icon as={Checked} {...props} />;

IconChecked.propTypes = Icon.propTypes;

export default IconChecked;
